import { useAuthStore } from "@/shared/store/useAuthStore";
import { Navigate, Outlet, useMatch } from "react-router";

const Auth: React.FC = function Auth() {
  const match = useMatch("/auth/sign-in");
  const { isAuth } = useAuthStore();

  if (isAuth) {
    return <Navigate to="/" replace />;
  }

  if (match !== null) {
    return <Outlet />;
  }

  return null;
};

export default Auth;
